import React from 'react';
import { Link } from 'react-router-dom';
import { blogPosts } from '../data/blogData';
import { ROUTES } from '../data/siteLinks';

const BlogPreview: React.FC = () => {
  // Gelecek tarihli yazıları listede gizle (planlı yayın için)
  const now = Date.now();
  const latestPosts = blogPosts
    .filter((p) => new Date(p.publishedAt).getTime() <= now)
    .slice(0, 3);

  return (
    <section className="blog-preview-section">
      <div className="container">
        {/* Başlık üstte */}
        <div className="blog-preview-header" style={{ justifyContent: 'center', marginBottom: '40px' }}>
          <h3 className="section-title">
            <Link to={ROUTES.blog} className="blog-preview-title-link">SON YAZILAR</Link>
          </h3>
        </div>
        {/* 3 yazı yan yana */}
        <div className="blog-preview-row">
          {latestPosts.map((post, index) => (
            <Link to={post.slug} key={index} className="blog-preview-card">
              <div className="blog-preview-image">
                {post.image ? (
                  <img src={post.image} alt={post.title} loading="lazy" />
                ) : (
                  <div className="blog-card-placeholder">
                    <span>📝</span>
                  </div>
                )}
              </div>
              <div className="blog-preview-content">
                <div className="blog-card-meta">
                  {post.date && <span className="blog-card-date">{post.date}</span>}
                  <span className="blog-card-reading-time">{post.readingTime}</span>
                </div>
                <h2 className="blog-preview-title">{post.title}</h2>
                <p className="blog-preview-excerpt">{post.excerpt}</p>
              </div>
            </Link>
          ))}
        </div>
        {/* Tüm Yazılar butonu en altta */}
        <Link to={ROUTES.blog} className="btn-teal blog-preview-btn">
          Tüm Yazılar
        </Link>
      </div>
    </section>
  );
};

export default BlogPreview;
